import { Box } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { ActionButton } from "../../../common/components/functional/actionBanner/styled";
import { useTranslation } from "react-i18next";

export interface InvoiceActionBannerPagingControlProps {
  currentInvoice: number;
  numberOfInvoices: number;
  cycleInvoices: (direction: number) => void;
}

export const InvoiceActionBannerPagingControl = ({
  currentInvoice,
  numberOfInvoices,
  cycleInvoices,
}: InvoiceActionBannerPagingControlProps) => {
  const { t } = useTranslation("common");

  return (
    <Box hidden={numberOfInvoices === 1}>
      <ActionButton variant="text" onClick={() => cycleInvoices(-1)}>
        <ArrowBackIcon />
        {t("back")}
      </ActionButton>
      {currentInvoice}/{numberOfInvoices}
      <ActionButton variant="text" onClick={() => cycleInvoices(1)}>
        {t("next")} <ArrowForwardIcon />
      </ActionButton>
    </Box>
  );
};
